export default __webpack_public_path__ + "static/media/dot.de01d5d0.svg";